import type { DocumentId } from '../../types';
import type { BaseDocumentModel } from './BaseDocument.model';

export class SearchDocumentResultHit<T = BaseDocumentModel> {
  ancestors?: DocumentId[];

  doc: T;

  id?: DocumentId;
}

export class SearchDocumentResults<T = BaseDocumentModel> {
  estimatedTotalHits: number;

  limit: number;

  offset: number;

  processingTimeMs: number;

  query: string;

  hits: SearchDocumentResultHit<T>[];

  docId: DocumentId;
}
